/* Forest Art & Frame, product page buying confidence panel.
   Pairs with snippets/ff-product-assurance.liquid. Liquid renders the panel
   complete for the selected variant, so it reads correctly without this
   script. This script only keeps the variant specific lines (size, lighting,
   delivery cost, LED only lines) in step when the customer changes option.
   Variant data comes from the JSON the snippet embeds, keyed by variant id.
   Two signals are used, whichever arrives: Dawn's PUB_SUB_EVENTS.variantChange
   and the change event Dawn fires on the product form's hidden id input. */
(function () {
  'use strict';

  function initPanel(panel) {
    if (!panel || panel.getAttribute('data-ffpa-ready') === '1') return;
    panel.setAttribute('data-ffpa-ready', '1');

    var data = {};
    try {
      var src = panel.querySelector('[data-ffpa-variants]');
      data = JSON.parse(src ? src.textContent : '{}') || {};
    } catch (e) {
      data = {};
    }

    var sectionId = panel.getAttribute('data-section') || '';
    var current = String(panel.getAttribute('data-variant') || '');

    function setRow(name, text) {
      var row = panel.querySelector('[data-ffpa-row="' + name + '"]');
      if (!row) return;
      var val = row.querySelector('[data-ffpa-val]');
      if (val) val.textContent = text || '';
      if (text) {
        row.removeAttribute('hidden');
      } else {
        row.setAttribute('hidden', '');
      }
    }

    function update(id) {
      if (!id) return;
      id = String(id);
      if (id === current) return;
      var v = data[id];
      if (!v) return;
      current = id;
      panel.setAttribute('data-variant', id);
      setRow('size', v.size);
      setRow('light', v.light);
      var cost = panel.querySelector('[data-ffpa-cost]');
      if (cost) cost.textContent = v.cost || '';
      var ledOnly = panel.querySelectorAll('[data-ffpa-led-only]');
      for (var i = 0; i < ledOnly.length; i++) {
        if (v.led) {
          ledOnly[i].removeAttribute('hidden');
        } else {
          ledOnly[i].setAttribute('hidden', '');
        }
      }
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data) return;
        if (event.data.sectionId && sectionId && event.data.sectionId !== sectionId) return;
        if (event.data.variant && event.data.variant.id) update(event.data.variant.id);
      });
    }

    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || t.name !== 'id') return;
      var form = t.form || (t.closest ? t.closest('form') : null);
      if (!form) return;
      if (form.id !== 'product-form-' + sectionId && form.id !== 'product-form-installment-' + sectionId) return;
      update(t.value);
    });
  }

  /* Enquiry links point at this template's enquiry band. If a product uses
     a template without one, fall back to any enquiry band on the page, then
     to the contact page. */
  function fixEnquiryLinks() {
    var links = document.querySelectorAll('[data-ffpa-enquiry]');
    for (var j = 0; j < links.length; j++) {
      var href = links[j].getAttribute('href') || '';
      var targetId = href.charAt(0) === '#' ? href.slice(1) : '';
      if (targetId && document.getElementById(targetId)) continue;
      var band = document.querySelector('.ffq-root:not([hidden])');
      if (band) {
        if (!band.id) band.id = 'ff-enquiry';
        links[j].setAttribute('href', '#' + band.id);
      } else {
        links[j].setAttribute('href', '/pages/contact');
      }
    }
  }

  function run() {
    var panels = document.querySelectorAll('[data-ffpa]');
    for (var i = 0; i < panels.length; i++) initPanel(panels[i]);
    fixEnquiryLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
